import type { AdventureContent } from "../types/adventure";
import { getActExplanation } from "./act-explanations";
import ruimtereis from "./adventures/ruimtereis/adventure.json";
import jungle from "./adventures/jungle/adventure.json";
import roadtrip from "./adventures/roadtrip/adventure.json";

function withActExplanation(adventure: Omit<AdventureContent, "actExplanation">): AdventureContent {
  return {
    ...adventure,
    actExplanation: getActExplanation(adventure.id),
  };
}

const adventureModules: AdventureContent[] = [
  withActExplanation(ruimtereis as Omit<AdventureContent, "actExplanation">),
  withActExplanation(jungle as Omit<AdventureContent, "actExplanation">),
  withActExplanation(roadtrip as Omit<AdventureContent, "actExplanation">),
];

const assetModules = import.meta.glob("./adventures/*/assets/*.{png,webp,jpg,svg}", {
  eager: true,
  query: "?url",
  import: "default",
}) as Record<string, string>;

function resolveAssetUrl(adventureId: string, filename: string): string | null {
  const key = Object.keys(assetModules).find(
    (k) => k.includes(`/adventures/${adventureId}/assets/${filename}`)
  );
  return key ? assetModules[key] : null;
}

export function getAdventures(): AdventureContent[] {
  return adventureModules;
}

export function getAdventure(id: string): AdventureContent | undefined {
  return adventureModules.find((a) => a.id === id);
}

export function resolveAdventureImages(
  adventure: AdventureContent
): Record<string, string | null> {
  const resolved: Record<string, string | null> = {};
  for (const [slot, filename] of Object.entries(adventure.images)) {
    resolved[slot] = resolveAssetUrl(adventure.id, filename);
  }
  for (const sys of adventure.systems) {
    const key = `system-${sys.id}`;
    const filename = adventure.images[key];
    if (filename) {
      resolved[key] = resolveAssetUrl(adventure.id, filename);
    }
  }
  return resolved;
}

export type ImageSlot =
  | "background"
  | "cockpit"
  | "goal"
  | "crash"
  | `round-${number}`
  | `system-${string}`;
